	// accordion transitions
	jQuery(".accordion").on("click", "li a", function (event) {
		if (!jQuery(this).hasClass("helplink")) {
			parentItem = jQuery(this).parent();
			if(parentItem.hasClass('active')){
				contentItem = parentItem.find(".content").first();

				contentItem.slideUp(400);
							contentItem.attr('aria-expanded', 'false');

					parentItem.removeClass("active");
							parentItem.attr('aria-expanded', 'false');
			}
			else {
					parentItem.addClass("active");
							parentItem.attr('aria-expanded', 'true');
				contentItem = parentItem.find(".content").first();
							contentItem.attr('aria-expanded', 'true');

				contentItem.slideDown(400);
			}
		}
	});

	jQuery(".accordion-reveal-all").on("click", function (e) {
		e.preventDefault();
		// get corresponding accordion id
		var this_accordion_id = jQuery(this).data("accordion-id");
		var selectedListItems = jQuery("#" + this_accordion_id + " li");

		// apply class to all sections in that accordian
		selectedListItems.addClass('active');
		selectedListItems.attr('aria-expanded', 'true');

		var selectedItemsContent = selectedListItems.find(".content");
		selectedItemsContent.addClass('active');
		selectedItemsContent.attr('aria-expanded', 'true');
		selectedItemsContent.slideDown("normal");
	});

	jQuery(".accordion-hide-all").on("click", function (e) {
		e.preventDefault();
		// get corresponding accordion id
		var this_accordion_id = jQuery(this).data("accordion-id");
		var selectedListItems = jQuery("#" + this_accordion_id + " li");

		// apply class to all sections in that accordian
		var selectedItemsContent = selectedListItems.find(".content");
		selectedItemsContent.slideUp("normal", function() {
			selectedListItems.removeClass('active');
			selectedItemsContent.removeClass('active');

			selectedListItems.attr('aria-expanded', 'false');
			selectedItemsContent.attr('aria-expanded', 'false');
		});

	});
